import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { FieldWriteNumberComponent } from '../field-write-number.component';
import { FormBuilder } from '@angular/forms';
import { Animations } from '../../../Animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-basic-field-number-w',
  templateUrl: './basic-field-number-w.component.html',
  styleUrls: ['./../Field-Styles.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class BasicFieldNumberWComponent extends FieldWriteNumberComponent implements OnInit {

  constructor(fb: FormBuilder, translateService: TranslateService) {
    super(fb, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
